import {ChangeDetectionStrategy, Component, HostListener, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {DialogType} from './common.dialog.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-common-dialog-notification',
  templateUrl: './common-dialog-notification.component.html',
  styleUrls: ['./common-dialog-notification.component.css']
})
export class CommonDialogNotificationComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    closeButtonText: string,
    message: string,
    dialogTitle: string,
    type: DialogType
  }, private mdDialogRef: MatDialogRef<CommonDialogNotificationComponent>) {
  }

  public cancel() {
    this.close(false);
  }

  public close(value) {
    this.mdDialogRef.close(value);
  }

  public confirm() {
    this.close(true);
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common-dialog-notification/common-dialog-notification.component.ts